import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import dashboardPageEmptyIcon from 'assets/images/icons/dashboard-page-empty.svg';
import plusIcon from 'assets/images/icons/plus.svg';
import FormButton from 'components/form-components/FormButton';

const EmptyDashboardPage = ({ setShowAddWidgetModal }) => {
  const { t } = useTranslation();

  return (
    <div className='w-100 h-75 d-flex flex-column gap-3 justify-content-center align-items-center'>
      <img className='dashboard-page-empty-icon' src={dashboardPageEmptyIcon} />
      <span className='theme-font-inter-semi-bold theme-text-black-1 theme-size-1_3'>
        {t('No visuals')}
      </span>
      <Fragment>
        <span>{t('Add widgets to start building your dashboard and view insights.')}</span>
        <FormButton
          text='button_add_widget'
          icon={plusIcon}
          iconClasses='svg-white'
          variant='green-1'
          onClick={() => setShowAddWidgetModal(true)}
        />
      </Fragment>
    </div>
  );
};

EmptyDashboardPage.propTypes = {
  setShowAddWidgetModal: PropTypes.func.isRequired,
};

export default EmptyDashboardPage;
